module.exports = __webpack_public_path__ + "static/media/sass.8b4a4ad7.svg";